import {
  DashboardAutoUpdate,
  HttpRequestError,
  MastersStatus,
  ConciliationStatus,
  SovosImportStatus,
  DashboardTotalsByCountry,
  ClosureEvolutionRow,
} from '../../types';
import {
  ActionType,
  ChangeAutoUpdateAction,
  FindAllRequestAction,
  FindMastersStatus2FailureAction,
  FindMastersStatus2RequestedAction,
  FindMastersStatus2SuccessAction,
  FindSovosImportStatusesRequestedAction,
  FindSovosImportStatusesSuccessAction,
  FindSovosImportStatusesFailureAction,
  FindDashboardConciliationsStateSuccessAction,
  FindDashboardConciliationsStateRequestedAction,
  FindDashboardConciliationsStateFailureAction,
  ChangeDashboardCountrySelectedAction,
  GetDashboardConciliationsStateYesterdaySuccessAction,
  GetDashboardConciliationsStateYesterdayFailureAction,
  GetDashboardConciliationsStateCurrentMonthSuccessAction,
  GetDashboardConciliationsStateCurrentMonthFailureAction,
  GetDashboardConciliationsStateLastMonthSuccessAction,
  GetDashboardConciliationsStateLastMonthFailureAction,
  FindDashboardConciliationsStateCardsRequestedAction,
  SetSingleCountryDashboardAction,
  FindDashboardTotalsCardsRequestedAction,
  GetDashboardTotalsYesterdaySuccessAction,
  GetDashboardTotalsYesterdayFailureAction,
  GetDashboardTotalsCurrentMonthSuccessAction,
  GetDashboardTotalsCurrentMonthFailureAction,
  GetDashboardTotalsLastMonthSuccessAction,
  GetDashboardTotalsLastMonthFailureAction,
  FindDashboardClosureEvolutionRequestedAction,
  GetDashboardClosureEvolutionSuccessAction,
  GetDashboardClosureEvolutionFailureAction,
} from './types';

export const findDashboardConciliationsStateRequested =
  (): FindDashboardConciliationsStateRequestedAction => ({
    type: ActionType.findDashboardConciliationsStateRequested,
  });

export const findDashboardConciliationsStateSuccess = (
  conciliationsState: ConciliationStatus[]
): FindDashboardConciliationsStateSuccessAction => ({
  type: ActionType.findDashboardConciliationsStateSuccess,
  conciliationsState,
});

export const findDashboardConciliationsFailure = (
  error: HttpRequestError
): FindDashboardConciliationsStateFailureAction => ({
  type: ActionType.findDashboardConciliationsStateFailure,
  error,
});

export const changeDashboardCountrySelected = (
  countryCode: string
): ChangeDashboardCountrySelectedAction => ({
  type: ActionType.changeDashboardCountrySelected,
  countryCode,
});

export const setSingleCountryDashboard = (
  countryCode: string
): SetSingleCountryDashboardAction => ({
  type: ActionType.setSingleCountryDashboard,
  countryCode,
});

// ================================================================================
// Conciliations State Cards
// ================================================================================

export const findDashboardConciliationsStateCardsRequested =
  (): FindDashboardConciliationsStateCardsRequestedAction => ({
    type: ActionType.findDashboardConciliationsStateCardsRequested,
    countryCode: '',
  });

export const getDashboardConciliationsStateYesterdaySuccess = (
  conciliationsStatusYesterday: ConciliationStatus[]
): GetDashboardConciliationsStateYesterdaySuccessAction => ({
  type: ActionType.getDashboardConciliationsStateYesterdaySuccess,
  conciliationsStatusYesterday,
});

export const getDashboardConciliationsStateYesterdayFailure = (
  error: HttpRequestError
): GetDashboardConciliationsStateYesterdayFailureAction => ({
  type: ActionType.getDashboardConciliationsStateYesterdayFailure,
  error,
});

export const getDashboardConciliationsStateCurrentMonthSuccess = (
  conciliationsStatusCurrentMonth: ConciliationStatus[]
): GetDashboardConciliationsStateCurrentMonthSuccessAction => ({
  type: ActionType.getDashboardConciliationsStateCurrentMonthSuccess,
  conciliationsStatusCurrentMonth,
});

export const getDashboardConciliationsStateCurrentMonthFailure = (
  error: HttpRequestError
): GetDashboardConciliationsStateCurrentMonthFailureAction => ({
  type: ActionType.getDashboardConciliationsStateCurrentMonthFailure,
  error,
});

export const getDashboardConciliationsStateLastMonthSuccess = (
  conciliationsStatusLastMonth: ConciliationStatus[]
): GetDashboardConciliationsStateLastMonthSuccessAction => ({
  type: ActionType.getDashboardConciliationsStateLastMonthSuccess,
  conciliationsStatusLastMonth,
});

export const getDashboardConciliationsStateLastMonthFailure = (
  error: HttpRequestError
): GetDashboardConciliationsStateLastMonthFailureAction => ({
  type: ActionType.getDashboardConciliationsStateLastMonthFailure,
  error,
});

// ================================================================================

export const changeAutoUpdateTimer = (autoUpdate: DashboardAutoUpdate): ChangeAutoUpdateAction => ({
  type: ActionType.changeAutoUpdate,
  autoUpdate,
});

export const findAllRequest = (): FindAllRequestAction => ({
  type: ActionType.findAllRequest,
});

export const findMastersStatus2Requested = (): FindMastersStatus2RequestedAction => ({
  type: ActionType.findMastersStatus2Requested,
});

export const findMastersStatus2Success = (
  mastersStatus: MastersStatus[]
): FindMastersStatus2SuccessAction => ({
  type: ActionType.findMastersStatus2Success,
  mastersStatus,
});

export const findMastersStatus2Failure = (
  error: HttpRequestError
): FindMastersStatus2FailureAction => ({
  type: ActionType.findMastersStatus2Failure,
  error,
});

export const findSovosImportStatusesRequested = (): FindSovosImportStatusesRequestedAction => ({
  type: ActionType.findSovosImportStatusesRequested,
});

export const findSovosImportStatusesSuccess = (
  sovosImportStatuses: SovosImportStatus[]
): FindSovosImportStatusesSuccessAction => ({
  type: ActionType.findSovosImportStatusesSuccess,
  sovosImportStatuses,
});

export const findSovosImportStatusesFailure = (
  error: HttpRequestError
): FindSovosImportStatusesFailureAction => ({
  type: ActionType.findSovosImportStatusesFailure,
  error,
});

// ================================================================================
// Totals Cards (FLEX vs SOVOS)
// ================================================================================

export const findDashboardTotalsCardsRequested = (): FindDashboardTotalsCardsRequestedAction => ({
  type: ActionType.findDashboardTotalsCardsRequested,
  countryCode: '',
});

export const getDashboardTotalsYesterdaySuccess = (
  totalsYesterday: DashboardTotalsByCountry[]
): GetDashboardTotalsYesterdaySuccessAction => ({
  type: ActionType.getDashboardTotalsYesterdaySuccess,
  totalsYesterday,
});

export const getDashboardTotalsYesterdayFailure = (
  error: HttpRequestError
): GetDashboardTotalsYesterdayFailureAction => ({
  type: ActionType.getDashboardTotalsYesterdayFailure,
  error,
});

export const getDashboardTotalsCurrentMonthSuccess = (
  totalsCurrentMonth: DashboardTotalsByCountry[]
): GetDashboardTotalsCurrentMonthSuccessAction => ({
  type: ActionType.getDashboardTotalsCurrentMonthSuccess,
  totalsCurrentMonth,
});

export const getDashboardTotalsCurrentMonthFailure = (
  error: HttpRequestError
): GetDashboardTotalsCurrentMonthFailureAction => ({
  type: ActionType.getDashboardTotalsCurrentMonthFailure,
  error,
});

export const getDashboardTotalsLastMonthSuccess = (
  totalsLastMonth: DashboardTotalsByCountry[]
): GetDashboardTotalsLastMonthSuccessAction => ({
  type: ActionType.getDashboardTotalsLastMonthSuccess,
  totalsLastMonth,
});

export const getDashboardTotalsLastMonthFailure = (
  error: HttpRequestError
): GetDashboardTotalsLastMonthFailureAction => ({
  type: ActionType.getDashboardTotalsLastMonthFailure,
  error,
});
// Closure Evolution
// ================================================================================

export const findDashboardClosureEvolutionRequested =
  (): FindDashboardClosureEvolutionRequestedAction => ({
    type: ActionType.findDashboardClosureEvolutionRequested,
    countryCode: '', // mismo patrón que usan ustedes
  });

export const getDashboardClosureEvolutionSuccess = (
  closureEvolution: ClosureEvolutionRow[]
): GetDashboardClosureEvolutionSuccessAction => ({
  type: ActionType.getDashboardClosureEvolutionSuccess,
  closureEvolution,
});

export const getDashboardClosureEvolutionFailure = (
  error: HttpRequestError
): GetDashboardClosureEvolutionFailureAction => ({
  type: ActionType.getDashboardClosureEvolutionFailure,
  error,
});

export const changeDashboardClosureEvolutionFilterStartAccountingDate = (startDate: Date) => ({
  type: ActionType.changeDashboardClosureEvolutionFilterStartAccountingDate,
  startDate,
});

export const changeDashboardClosureEvolutionFilterEndAccountingDate = (endDate: Date) => ({
  type: ActionType.changeDashboardClosureEvolutionFilterEndAccountingDate,
  endDate,
});
